import { toast } from 'sonner'
import { getErrorMessageFromError } from '~/shared/lib/api-errors'

/** Opens a PDF behind a short-lived link in a new tab, reserved before the wait so it is not blocked. */
export async function openDocument(load: () => Promise<string>): Promise<void> {
  const tab = window.open('', '_blank')
  try {
    const url = await load()
    if (tab) tab.location.href = url
    else window.location.href = url
  } catch (error) {
    tab?.close()
    toast.error(getErrorMessageFromError(error))
  }
}
